import {animate, animateChild, group, query, state, style, transition, trigger} from '@angular/animations';

export function routerFlipTransition() {
  return flip();
}

export function slideToRight() {
  return trigger('routerTransition', [
    state('void', style({position: 'fixed', width: '100%'})),
    state('*', style({position: 'fixed', width: '100%'})),
    transition(':enter', [
      style({transform: 'translateX(-100%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(0%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateX(0%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(100%)'}))
    ])
  ]);
}

export const slideInAnimation =
  trigger('routeAnimation', [
    transition('* => *', [
      style({position: 'relative'}),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({left: '-100%'})
      ], { optional: true }),
      query(':leave', animateChild(), { optional: true }),
      group([
        query(':leave', [
          animate('500ms ease-in-out', style({left: '100%'}))
        ], { optional: true }),
        query(':enter', [
          animate('500ms ease-in-out', style({left: '0%'}))
        ], { optional: true })
      ]),
      query(':enter', animateChild(), { optional: true }),
    ])
  ]);

export const slideToLeft = trigger('routerTransition', [
  transition('heroes <=> hero', [
    style({position: 'relative'}),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%'
      })
    ]),
    query(':enter', [
      style({left: '-100%'})
    ]),
    query(':leave', animateChild()),
    group([
      query(':leave', [
        animate('300ms ease-out', style({left: '100%'}))
      ]),
      query(':enter', [
        animate('300ms ease-out', style({left: '0%'}))
      ])
    ]),
    query(':enter', animateChild()),
  ])
]);


export function slideToLefts() {
  return trigger('routerTransition', [
    transition('heroes <=> hero', [
      style({position: 'relative'}),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ]),
      query(':enter', [
        style({left: '-100%'})
      ]),
      query(':leave', animateChild()),
      group([
        query(':leave', [
          animate('300ms ease-out', style({left: '100%'}))
        ]),
        query(':enter', [
          animate('300ms ease-out', style({left: '0%'}))
        ])
      ]),
      query(':enter', animateChild()),
    ])
  ]);
}

export function slideToLeft1() {
  return trigger('routerTransition', [
    state('void', style({position: 'inherit'})),
    state('*', style({position: 'inherit'})),
    transition(':enter', [
      style({transform: 'translateX(100%)', position: 'fixed', width: '100%'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(0%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateX(0%)', position: 'fixed', width: '100%'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(-100%)'}))
    ])
  ]);
}

export function slideToBottom() {
  return trigger('routerTransition', [
    state('void', style({position: 'fixed', width: '100%', height: '100%'})),
    state('*', style({position: 'fixed', width: '100%', height: '100%'})),
    transition(':enter', [
      style({transform: 'translateY(-100%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateY(0%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateY(0%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateY(100%)'}))
    ])
  ]);
}

export function slideToTop() {
  return trigger('routerTransition', [
    state('void', style({position: 'fixed', width: '100%', height: '100%'})),
    state('*', style({position: 'fixed', width: '100%', height: '100%'})),
    transition(':enter', [
      style({transform: 'translateY(100%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateY(0%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateY(0%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateY(-100%)'}))
    ])
  ]);
}

export function flip() {
  return trigger('routerTransition', [
    state('void', style({position: 'fixed', width: '100%', height: '100%'})),
    state('*', style({position: 'inherit', width: '100%', height: '100%'})),
    transition(':enter', [
      style({transform: 'rotateY(179.9deg)'}),
      animate('0.5s ease-in-out', style({position: 'fixed', transform: 'rotateY(0)'}))
    ]),
    transition(':leave', [
      style({transform: 'rotateY(0)'}),
      animate('0.5s ease-in-out', style({position: 'fixed', transform: 'rotateY(179.9deg)'}))
    ])
  ]);
}
